import { getCurrentIdToken } from './chatbotApiRequest';

interface AuthRetryDeps {
  token: string;
  ensureValidSession: () => Promise<boolean>;
}

async function fetchWithAuthRetry(
  sendRequest: (authToken: string) => Promise<Response>,
  deps: AuthRetryDeps,
  makeError: (status: number, message: string) => Error,
): Promise<Response> {
  const response = await sendRequest(deps.token);
  if (response.status !== 401) {
    return response;
  }

  const recovered = await deps.ensureValidSession();
  if (!recovered) {
    throw makeError(401, 'Invalid token');
  }

  let freshToken: string;
  try {
    freshToken = await getCurrentIdToken();
  } catch {
    throw makeError(401, 'Invalid token');
  }

  const retryResponse = await sendRequest(freshToken);
  if (retryResponse.status === 401) {
    throw makeError(401, 'Invalid token');
  }

  return retryResponse;
}

export { fetchWithAuthRetry };
